module.exports = __webpack_public_path__ + "img/arrow-up.3808d262.svg";